// eslint-disable-next-line import/prefer-default-export
export const filterPropertiesCropZones = (
  properties,
  seasonIds,
  cropId,
  initiallySelectedCropZoneIds = []
) => {
  const selectedCropZoneIds = new Set(initiallySelectedCropZoneIds);

  const isInitiallySelected = cropZone => {
    return selectedCropZoneIds.has(cropZone.id);
  };

  const filterCropZones = field => {
    return field.cropzones.filter(
      cz =>
        (!cz.archived || isInitiallySelected(cz)) &&
        (!cropId || cz.crop.id === cropId) &&
        cz.cropSeasons.some(season => seasonIds.includes(season.id))
    );
  };

  const mapFields = property => {
    const newFields = property.fields
      .map(field => {
        const filteredCropZones = filterCropZones(field);
        const hasSelectedCropZone = filteredCropZones.some(isInitiallySelected);

        return {
          ...field,
          cropzones: filteredCropZones,
          _hasSelectedCropZone: hasSelectedCropZone
        };
      })
      .filter(field => {
        return (
          field.cropzones.length > 0 &&
          (!field.archived || field._hasSelectedCropZone)
        );
      })
      .map(({ _hasSelectedCropZone, ...field }) => field)
      .sort((a, b) => (a.archived ? 1 : 0) - (b.archived ? 1 : 0));

    const hasSelectedCropZoneInProperty = newFields.some(field =>
      field.cropzones.some(isInitiallySelected)
    );

    return {
      ...property,
      fields: newFields,
      _hasSelectedCropZoneInProperty: hasSelectedCropZoneInProperty
    };
  };

  const filteredProperties = properties
    .map(mapFields)
    .filter(property => {
      return (
        property.fields.length > 0 &&
        (!property.archived || property._hasSelectedCropZoneInProperty)
      );
    })
    .map(({ _hasSelectedCropZoneInProperty, ...property }) => property)
    .sort((a, b) => (a.archived ? 1 : 0) - (b.archived ? 1 : 0));

  return filteredProperties;
};
